// schema
import * as ISchema from "@schema";
import { compact } from "lodash";
import {
  ExperimentMappingType,
  ExperimentNameType,
  EXPERIMENT_FLAGS,
} from "@clockwise/client-commons/src/util/experiment";
export { EXPERIMENT_FLAGS };
export type { ExperimentNameType };

import { experiments, cachedExperiments } from "@state/local-storage";

export function isOnSuggestionsFeed(org: ISchema.IOrg | null) {
  return isOn(org, EXPERIMENT_FLAGS.suggestionsFeed);
}

export function isOnWeekInReviewOnProfile(org: ISchema.IOrg | null) {
  return isOn(org, EXPERIMENT_FLAGS.weekInReviewOnProfile);
}

export function isOnDisableHealthChecks() {
  return isOn(null, EXPERIMENT_FLAGS.disableHealthChecks);
}

export function isOnShowLogs() {
  return isOn(null, EXPERIMENT_FLAGS.showLogs);
}

export function isOnInlineSchedulingSuggestions(org: ISchema.IOrg | null) {
  return isOn(org, EXPERIMENT_FLAGS.inlineSchedulingSuggestions);
}

export function isOnCreateEventAutopick(org: ISchema.IOrg | null) {
  return isOn(org, EXPERIMENT_FLAGS.createEventAutopick);
}

export function isOnSupportEngineerInterviewFrontEndBug() {
  return isOn(null, EXPERIMENT_FLAGS.supportEngineerInterviewFrontEndBug);
}

export function isOnAdvancedUserLogging() {
  return isOn(null, EXPERIMENT_FLAGS.advancedUserLogging);
}

export function isOnSuperchargedNUX(org?: ISchema.IOrg) {
  return isOn(org || null, EXPERIMENT_FLAGS.superchargedNUX);
}

export function isOnCalendarEventModal() {
  return isOn(null, EXPERIMENT_FLAGS.calendarEventModal);
}

export function isOnDraggableWorkingHours() {
  return isOn(null, EXPERIMENT_FLAGS.draggableWorkingHours);
}

export function isOnTrackLogging() {
  return isOn(null, EXPERIMENT_FLAGS.trackLogging);
}

export function isOnTriggerDefrag() {
  return isOn(null, EXPERIMENT_FLAGS.triggerDefrag);
}

export function isOnToolTipDebugging(org?: OrgWithExperiments) {
  return isOn(org || null, EXPERIMENT_FLAGS.toolTipDebugging);
}

export function isOnSlackDogfoodApp() {
  return isOn(null, EXPERIMENT_FLAGS.slackDogfoodApp);
}

export function isOnHeatmap(org?: ISchema.IOrg) {
  return isOn(org || null, EXPERIMENT_FLAGS.heatmap);
}

export interface OrgWithExperiments {
  experiments?: (string | null | undefined)[] | null | undefined;
}

export function getBulkExperiments(org: OrgWithExperiments | null): ExperimentMappingType {
  return Object.values(EXPERIMENT_FLAGS).reduce(
    (acc, expName: ExperimentNameType) => ({
      ...acc,
      [expName]: isOn(org, expName),
    }),
    {} as ExperimentMappingType,
  );
}

export function isOn(org: OrgWithExperiments | null, experiment: ExperimentNameType) {
  // update our cached experiments if org is present
  if (org && org.experiments) {
    cachedExperiments.setAll(
      compact(org.experiments).reduce((accum, curr) => {
        accum[curr] = true;
        return accum;
      }, {} as { [key: string]: boolean }),
    );
  }

  // check local storage override but only if we have an org
  const isOnLocally = experiments.getFlag(experiment);

  // also check last cache of org experiments
  const isOnCached = cachedExperiments.getFlag(experiment);

  // finally, check if present on org experiments
  const isOnServer =
    (org && org.experiments && org.experiments.indexOf(experiment) !== -1) || false;

  // will return true as long as one of our four sources has the experiment on
  return isOnLocally || isOnCached || isOnServer;
}
